import { navigate } from 'gatsby'

export const QUOTE_SUBMISSION_KEY = 'forkliftSolutionsQuoteSubmission'
export const BOOKING_SUBMISSION_KEY = 'forkliftSolutionsBookingSubmission'

export function goToFormConfirmation(path, storageKey, summary) {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(summary))
  } catch (err) {
    // Ignore storage failures; navigation state is the primary handoff.
  }
  navigate(path, { state: { summary } })
}
